<app-modal-filler-atom
  [index]="(index$ | async) ?? 0"
  (onClick)="close()"
></app-modal-filler-atom>
<div
  class="fixed left-0 right-0 mx-auto shadow"
  [ngClass]="
    (isMobile$ | async)
      ? 'max-w-screen-sm'
      : 'flex justify-center items-center w-full h-full top-0 left-0'
  "
  [style.z-index]="((index$ | async) ?? 0) + 50"
  [style.bottom.px]="keyboardOffset"
  [style.max-height]="
    availableHeight ? availableHeight + 'px' : (isMobile$ | async) ? '85vh' : null
  "
  [class.bottom-0]="keyboardOffset === 0 && (isMobile$ | async)"
>
  <app-modal-filler-atom
    class="hidden md:block"
    [index]="(index$ | async) ?? 0"
    (onClick)="close()"
  ></app-modal-filler-atom>
  <div
    class="bg-white p-5 md:p-7 overflow-y-auto"
    [ngClass]="(isMobile$ | async) ? 'rounded-t-3xl' : 'rounded-3xl min-w-448'"
    [style.z-index]="((index$ | async) ?? 0) + 50"
    [style.max-height]="
      availableHeight ? availableHeight - 20 + 'px' : (isMobile$ | async) ? '85vh' : null
    "
  >
    <div class="mb-7">
      <div class="mb-4">
        @if (distributionModeItems?.length === 1) {
          <div
            class="mb-4 w-full rounded-full bg-neutral-100 py-3.5 px-4 text-center text-base font-bold text-neutral-800"
          >
            {{ distributionModeItems[0].label | translate }}
          </div>
        }
        @if ((distributionModeItems?.length ?? 0) > 1 && (distributionModeItems?.length ?? 0) < 3) {
          <div class="mx-auto mb-4 max-w-sm">
            <app-parameters-distribution-mode-block
              [selectedDistributionMode]="selectedDistributionMode"
              [isCartParameters]="true"
              [items]="distributionModeItems"
              (selectItem)="distributionModeSelectionChanged($event)"
            ></app-parameters-distribution-mode-block>
          </div>
        }
        @if ((distributionModeItems?.length ?? 0) >= 3) {
          <div class="mx-auto mb-4 max-w-sm">
            <app-custom-select-atom
              [items]="distributionModeItems"
              [selectedItem]="selectedDistributionMode"
              (selectItem)="distributionModeSelectionChanged($event)"
            ></app-custom-select-atom>
          </div>
        }
      </div>
      @if (selectedOrderTypeCapabilities.isDeliveryAddressMandatory) {
        <div>
          <app-parameters-location-block
            [selectedValue]="selectedLocation ?? ''"
            [selectedCommentValue]="deliveryComment"
            (placeChanged)="locationChanged($event)"
          ></app-parameters-location-block>
        </div>
      }
    </div>

    <!-- Delivery Instructions -->
    @if (
      selectedDistributionMode === distributionMode.Delivery &&
      !((userIsLoggedIn$ | async) && selectedLocation && (instructions$ | async))
    ) {
      <div class="mx-auto mb-7 max-w-sm">
        <app-parameters-delivery-instructions-block
          [instructions]="$any(instructions$ | async)"
          (instructionsChanged)="deliveryCommentChanged($any($event))"
        ></app-parameters-delivery-instructions-block>
      </div>
    }

    @if (message) {
      <div class="my-4 rounded-md bg-neutral-50 p-4 font-base text-sm text-neutral-700">
        {{ message }}
      </div>
    }

    @if (selectedOrderTypeCapabilities.preorderingAllowed) {
      <div class="mb-7">
        <app-parameters-wanted-at-block
          [dateSlots]="wantedAtDateSlots"
          [timeSlots]="wantedAtTimeSlots"
          [wantedAtType]="selectedWantedAtType"
          [wantedAtDate]="selectedWantedAtDate"
          [wantedAtTime]="selectedWantedAtTime"
          [displayAsapForLaterPicker]="displayAsapForLaterPicker"
          (typeChanged)="onWantedAtTypeChanged($event)"
          (dateChanged)="onWantedAtDateChanged($event)"
          (timeChanged)="onWantedAtTimeChanged($event)"
        ></app-parameters-wanted-at-block>
      </div>
    }
    <app-button-atom
      [color]="'primary'"
      [label]="'parameters.validate' | translate"
      [type]="'primary'"
      [size]="'L'"
      (click)="save()"
    ></app-button-atom>
  </div>
</div>
